// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

interface Props {
  formValues: {
    data: {
      id?: number;
      name?: string;
    };
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
function OnlyNameForm(props: Props): JSX.Element {
  const { data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.name || ''}
            name="name"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
    </fieldset>
  );
}

export default OnlyNameForm;
